import Vue from 'vue'
import Toasted from 'vue-toasted'

Vue.use(Toasted, {
    iconPack: 'fontawesome',
    duration: 7000
})

Vue.toasted.register(
    'defaultSuccess',
    payload => !payload.msg ? 'Operação realidada com sucesso!' : payload.msg,
    { type: 'success', icon: 'check', theme: "bubble", position: "top-center"  }
)

Vue.toasted.register(
    'defaultError',
    payload => !payload.msg ? 'Ocorreu um erro inesperado.' : payload.msg,
    { type : 'error', icon : 'times', theme: "bubble", position: "top-center"  }
)

Vue.toasted.register(
    'defaultInfo',
    payload => !payload.msg ? 'Há requisitos ausentes!' : payload.msg,
    { type : 'info', icon : 'info', theme: "bubble", position: "top-center" }
)